<template>
  <section class="section">
    <div class="container">
      <div class="tabs is-right">
        <ul>
          <router-link tag="li" :to="{ name: 'adminregistros.newempresa' }">
            <a>
              <span class="icon is-small">
                <span class="material-icons">list_alt</span>
              </span>
              <span>Crear Empresa</span>
            </a>
          </router-link>
          <router-link tag="li" :to="{ name: 'adminregistros.editproducto' }">
            <a>
              <span class="icon is-small">
                <span class="material-icons">list_alt</span>
              </span>
              <span>Producto</span>
            </a>
          </router-link>
          <router-link tag="li" :to="{ name: 'adminregistros.habilitacion' }">
            <a>
              <span class="icon is-small">
                <span class="material-icons">list_alt</span>
              </span>
              <span>Habilitar Facturacion</span>
            </a>
          </router-link>
          <router-link tag="li" :to="{ name: 'adminregistros.delete' }">
            <a>
              <span class="icon is-small">
                <span class="material-icons">list_alt</span>
              </span>
              <span>Borrar</span>
            </a>
          </router-link>
          <router-link tag="li" :to="{ name: 'adminregistros.addsellers' }">
            <a>
              <span class="icon is-small">
                <span class="material-icons">playlist_add</span>
              </span>
              <span>Agregar Vendedores</span>
            </a>
          </router-link>
          <router-link tag="li" :to="{ name: 'adminregistros.inventory' }">
            <a>
              <span class="icon is-small">
                <span class="material-icons">assignment</span>
              </span>
              <span>Inventarios</span>
            </a>
          </router-link>
          <router-link tag="li" :to="{ name: 'adminregistros.documents' }">
            <a>
              <span class="icon is-small">
                <span class="material-icons">article</span>
              </span>
              <span>Documentos</span>
            </a>
          </router-link>
        </ul>
      </div>
      <div v-if="isinicial">
        <div class="notification">
          <h1 class="title is-4">Registos</h1>
          <h2 class="subtitle is-6">
            Modulo para borrar editar hacer cambios en los registros contables.
          </h2>
          <p>En este modulo podra hacer temas delicados de la aplicación.</p>
        </div>
        <button class="button is-link" @click="addconsxml">
          Agregar consecutivo xml a la factura electronica
        </button>
      </div>
      <transition name="fade">
        <router-view></router-view>
      </transition>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.tabs li.router-link-exact-active a {
  border-bottom-color: #3273dc;
  border-bottom-width: 2px;
  color: #3273dc;
}
</style>

<script>
import apiServices from "@/services/yungol-services";
export default {
  data() {
    return {
      routeaqui: null,
    };
  },
  methods: {
    async addconsxml() {
      try {
        const result = await apiServices.get(`addconsxml`);
        console.log(result.data);
      } catch (err) {
        console.log(err);
      }
    },
  },
  computed: {
    isinicial() {
      return this.$route.name === "adminregistros";
    },
  },
  created() {
    this.routeaqui = this.$route.name;
  },
};
</script>


// WEBPACK FOOTER //
// src/components/admin/registros/Registros.vue